const routes = [
    // 外教约课记录
    {
      path: "/foreignRecords",
      name: "foreignRecords",
      meta: {
        title: "约课记录",
        volcengine: true
      },
      component: () => import("@/pages/lsForeign/foreignRecords/index.vue")
    },
  ];
  export default routes;
  